export const MY_LIST = "myList"
export const MY_DRAFTS = "myDrafts"
export const MY_PUBLISHED = "myPublished"
export const MY_RETIRED = "myRetired"
